import { versionCompare } from '../../version';
import Detector from '../../detector';
import defaultStrategy from './default-login';

const mapVersion = '2.3.0';

export default {
  name: 'tantumap',
  isLogin: defaultStrategy.isLogin,
  gotoLogin() {
    const zzc = window.zzc;
    if (zzc && versionCompare(Detector.browser.fullVersion, mapVersion)) {
      return zzc.call('page_linkTo', {
        url: '/login/',
        success(response) {
          console.log(response);
        }
      });
    }
    return defaultStrategy.gotoLogin();
  },
  clearLogin: defaultStrategy.clearLogin
};
